__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "bellwether-ai-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@tanstack/react-query", "5.90.7", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(685)]).then(() => (() => (__webpack_require__(2040))))));
			register("react-dom/client", "18.3.1", () => (() => (__webpack_require__(5338))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-router-dom", "7.18.2", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(2886))))));
			register("react/jsx-runtime", "18.3.1", () => (() => (__webpack_require__(4848))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
			initExternal(7483);
			initExternal(2775);
			initExternal(8923);
			initExternal(9217);
			initExternal(9215);
			initExternal(429);
			initExternal(4006);
			initExternal(881);
			initExternal(2654);
			initExternal(3286);
			initExternal(1210);
			initExternal(7782);
			initExternal(4714);
			initExternal(2590);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};